import { createContext, useContext } from 'react';

const defaultValue = {
  permissions: null,
  permissionsReady: false,
  permissionSignature: '',
  refreshPermissions: () => Promise.resolve(null),
};

const PermissionsSyncContext = createContext(defaultValue);

export const PermissionsSyncProvider = PermissionsSyncContext.Provider;

export const usePermissionsSync = () => useContext(PermissionsSyncContext);

export default PermissionsSyncContext;
